export default __webpack_public_path__ + "media/images/dividers/black-tear-d2d57d74944de3b0d7898d4df064b821.svg";